import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

import { LEAD_TYPES } from "modules/LeadsDashboard";
import { setSelectedLeadType, useSelectedLeadType } from "modules/LeadsDashboard/hooks";

import type { DropdownItemProps } from "components/Dropdown";

export const LeadTypeFilter = () => {
  const { t } = useTranslation();

  const selectedLeadType = useSelectedLeadType();

  const leadsTypeOptions: DropdownItemProps[] = useMemo(
    () => [
      { key: LEAD_TYPES.Snoozed, value: LEAD_TYPES.Snoozed, text: t("v8_snoozed", "Snoozed") },
      { key: LEAD_TYPES.NotSnoozed, value: LEAD_TYPES.NotSnoozed, text: t("v8_not_snoozed", "Not Snoozed") },
      { key: LEAD_TYPES.Cars, value: LEAD_TYPES.Cars, text: t("v8_cars", "Cars") },
      { key: LEAD_TYPES.Tires, value: LEAD_TYPES.Tires, text: t("v8_tires", "Tires") }
    ],
    []
  );

  return (
    <Dropdown
      fluid
      selection
      selectOnBlur={false}
      value={selectedLeadType}
      options={leadsTypeOptions}
      placeholder={t("v8_leads_type", "Leads Type")}
      onChange={(_e, data) => setSelectedLeadType(data.value as LEAD_TYPES)}
    />
  );
};
